import { ReactNode } from "react"
import { Link, useLocation } from "react-router-dom"
import { getDisabledDeploymentFeature } from "@/shared/config/deployment-features"

export const DeploymentFeatureGate = ({ children }: { children: ReactNode }) => {
    const { pathname } = useLocation()
    if (!getDisabledDeploymentFeature(pathname)) return <>{children}</>

    return (
        <div className="w-full flex-1 font-manrope flex items-center justify-center px-6">
            <div className="info_panel max-w-[720px] text-center text-color-base">
                <p>Раздел сейчас недоступен.</p>
                <Link to="/" className="underline">На главную</Link>
            </div>
        </div>
    )
}
